import { render, staticRenderFns } from "./DetailProspect.vue?vue&type=template&id=057dcea6&"
import script from "./DetailProspect.vue?vue&type=script&lang=js&"
export * from "./DetailProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports